module.exports = __webpack_public_path__ + "static/media/Info_image.ca45a6ae.svg";